<template>
  <v-container class="d-flex align-start justify-center" fill-height>
    <v-row no-gutters>
      <v-col xs="12" offset-xs="0" sm="10" offset-sm="1" md="8" offset-md="2">
        <h1 class="mt-5">Mis direcciones</h1>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col
        class="py-0"
        v-for="(dir) in direccionesFiltradas"
        :key="dir.id_direccion"
        xs="12"
        offset-xs="0"
        sm="10"
        offset-sm="1"
        md="8"
        offset-md="2"
      >
        <v-hover v-slot:default="{ hover }">
          <v-card
            @click.stop="pedir(dir)"
            elevation="0"
            :color="hover ? 'grey lighten-4' : 'transparent'"
            tile
            class="w-100"
          >
            <direccion-card v-bind:obj="dir" />
          </v-card>
        </v-hover>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import direccionCard from "@/components/Pedidos/pedir_direccionCard.vue";
export default {
  components: {
    direccionCard
  },
  data() {
    return {
      loadingAddress: false,
      selectedCheckboxBtn: ""
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    direcciones: function() {
      return this.user && this.user.direcciones ? this.user.direcciones : [];
    },
    direccionesFiltradas: function() {
      let _vue = this;
      let res = [];
      res = this.direcciones;
      // this.direcciones.forEach(function(e){
      //  if(typeof(e.coordenadas) == "string"){
      //      e.coordenadas = [parseFloat(e.coordenadas.split(",")[0]), parseFloat(e.coordenadas.split(",")[1])];
      //  }
      // })

      // let sortedDir = this.direcciones.sort(function(a, b){
      //      let a2 = a.predeterminada ? 1 : 0;
      //      let b2 = b.predeterminada ? 1 : 0;
      //      return a2 > b2;
      //  });

      // return sortedDir.reverse();
      return res;
    }
  },
  methods: {
    pedir(dir) {
      let _vue = this;
      this.selectedCheckboxBtn = dir;
      this.loadingAddress = true;
      setTimeout(function() {
        _vue.$store.commit(
          "direcciones/setDirPidiendo",
          _vue.selectedCheckboxBtn
        );
        _vue.$store
          .dispatch("direcciones/comprobarDireccion")
          .then(function(res) {})
          .finally(function() {
            _vue.loadingAddress = false;
          });
      }, 2000);
    },
    ...mapActions({
      getDirecciones: "direcciones/getDirecciones"
    })
  },
  mounted() {
    //this.getDirecciones();
  }
};
</script>

<style>
</style>